jQuery(document).ready(
    function ($) {
        (function ($) { var $modal = $('#prrModal'); var $dialog = $modal.find('.prr-modal__dialog'); var $openers = $('.prr-open-modal'); var $close = $modal.find('.prr-modal__close'); var lastFocus = null; function lockScroll(lock) { if (lock) $('body').css('overflow', 'hidden'); else $('body').css('overflow', ''); } function openModal() { lastFocus = document.activeElement; $modal.attr('aria-hidden', 'false').show(); lockScroll(true); setTimeout(function () { $dialog.trigger('focus'); }, 0); } function closeModal() { $modal.attr('aria-hidden', 'true').hide(); lockScroll(false); if (lastFocus && typeof lastFocus.focus === 'function') $(lastFocus).trigger('focus'); } $openers.on('click', function (e) { e.preventDefault(); openModal(); }); $close.on('click', function () { closeModal(); }); $modal.on('click', function (e) { if ($(e.target).is('.prr-modal__backdrop')) closeModal(); }); $(document).on('keydown', function (e) { if ($modal.is(':visible') && e.key === 'Escape') closeModal(); }); $dialog.on('keydown', function (e) { if (e.key !== 'Tab') return; var $focusable = $dialog.find('a,button,textarea,input,select,[tabindex]:not([tabindex="-1"])').filter(':visible'); if (!$focusable.length) return; var first = $focusable[0], last = $focusable[$focusable.length - 1]; if (e.shiftKey && document.activeElement === first) { e.preventDefault(); $(last).trigger('focus'); } else { if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); $(first).trigger('focus'); } } }); })(jQuery); const groupTitles = document.querySelectorAll('h3.group-title'); groupTitles.forEach((title, index) => { const toggleIcon = title.querySelector('.toggle-icon'); if (index < 2) { if (toggleIcon) toggleIcon.remove(); } else { if (toggleIcon) title.classList.add('has-toggle'); } }); const groups = document.querySelectorAll('.row.group-content'); groups.forEach((el, index) => { if (index < 2) el.style.display = 'flex'; }); $('.ressciencediv .group-title').on('click', function () { const $content = $(this).next('.group-content'); const $plus = $(this).find('.plus-icon'); const $minus = $(this).find('.minus-icon'); $content.slideToggle(200); $plus.toggle(); $minus.toggle(); }); var $carouselInner = $('#homecarousel .carousel-inner'); var $slides = $carouselInner.children('.carousel-item'); if ($slides.length >= 5) { var $fifth = $slides.eq(4); $slides.removeClass('active'); $('#homecarousel .carousel-indicators button').removeClass('active').removeAttr('aria-current'); $fifth.prependTo($carouselInner); $carouselInner.children('.carousel-item').first().addClass('active'); $('#homecarousel .carousel-indicators button').first().addClass('active').attr('aria-current', 'true'); } $('.carousel').carousel({ interval: 20000 }); $('#homecarousel').css('visibility', 'visible'); $('.carousel').carousel({ interval: 20000 }); var options = { log: true, autoResize: true };
});

(function ($) {
$(document).on('click','.toggle-all',function(){
$(".collapse").collapse("toggle");
 $(this).toggleClass("active");
	  $(this).text("COLLAPSE ALL");
  if ($(this).hasClass("active")) {
    $(this).text("EXPAND ALL");
  } else {
    $(this).text("COLLAPSE ALL");
  }
});


	 $('.toTop').click(function(){
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
    });
  $("#toTop").on({
   mouseenter: function(){
    $(this).attr('src','/images/existing/Brown_Up_Hover.png');
  },
  mouseleave: function(){
    $(this).attr('src','/images/existing/Brown_Up.png');
  }
  });
$(document).ready(function() {
  $('#toggleButton').on('click', function() {
    $('#dropdownMenu').slideToggle(); // Toggle visibility of the dropdown menu
  });

  // Optional: Close dropdown if clicking outside
  $(document).on('click', function(event) {
    if (!$(event.target).closest('#toggleButton, #dropdownMenu').length) {
      $('#dropdownMenu').slideUp(); // Close dropdown if clicking outside
    }
  });
});

	$( document ).ready(function() {

	 	$('.dropdown-menu').each(function () {
  $(this).hover(function() {
     	$(this).prev('.dropdown-toggle').toggleClass('opendr');

});
	});
   $(".hider").hide();
     $(".hiderv").hide();

$( ".shower" ).click(function() {
			$(".crispsub").slideDown();
    $(".shower").hide();
    $(".hider").show();
});
$( ".hider" ).click(function() {
			$(".crispsub").slideUp();
    $(".hider").hide();
    $(".shower").show();
});

$( ".showerv" ).click(function() {
			$(".virushelpsub").slideDown();
    $(".showerv").hide();
    $(".hiderv").show();
});
$( ".hiderv" ).click(function() {
			$(".virushelpsub").slideUp();
    $(".hiderv").hide();
    $(".showerv").show();
});
		$('.shower').each(function () {
		  $(this).mouseenter(function () {
			$(this).attr('src','/images/existing/Brown_More_Hover.png');
		  });
	});
	  	$('.shower').each(function () {
		  $(this).mouseleave(function () {
			$(this).attr('src','/images/existing/Brown_More.png');
		  });
	});
					$('.showerv').each(function () {
		  $(this).mouseenter(function () {
			$(this).attr('src','/images/existing/Brown_More_Hover.png');
		  });
	});
	  	$('.showerv').each(function () {
		  $(this).mouseleave(function () {
			$(this).attr('src','/images/existing/Brown_More.png');
		  });
	});
		$('.shower1').each(function () {
		  $(this).mouseenter(function () {
			$(this).attr('src','/images/existing/Brown_More_Hover.png');
		  });
	});
	  	$('.shower1').each(function () {
		  $(this).mouseleave(function () {
			$(this).attr('src','/images/existing/Brown_More.png');
		  });
	});
	$('.hider1').each(function () {
		  $(this).mouseenter(function () {
			$(this).attr('src','/images/existing/Brown_Less_Hover.png');
		  });
	});
	  	$('.hider1').each(function () {
		  $(this).mouseleave(function () {
			$(this).attr('src','/images/existing/Brown_Less.png');
		  });
	});
		$('.hider').each(function () {
		  $(this).mouseenter(function () {
			$(this).attr('src','/images/existing/Brown_Less_Hover.png');
		  });
	});
	  	$('.hider').each(function () {
		  $(this).mouseleave(function () {
			$(this).attr('src','/images/existing/Brown_Less.png');
		  });
	});
					$('.hiderv').each(function () {
		  $(this).mouseenter(function () {
			$(this).attr('src','/images/existing/Brown_Less_Hover.png');
		  });
	});
	  	$('.hiderv').each(function () {
		  $(this).mouseleave(function () {
			$(this).attr('src','/images/existing/Brown_Less.png');
		  });
	});
		$('.shower2').each(function () {
		  $(this).mouseenter(function () {
			$(this).attr('src','/images/existing/Brown_More_Hover.png');
		  });
	});
	  	$('.shower2').each(function () {
		  $(this).mouseleave(function () {
			$(this).attr('src','/images/existing/Brown_More.png');
		  });
	});
	$('.hider2').each(function () {
		  $(this).mouseenter(function () {
			$(this).attr('src','/images/existing/Brown_Less_Hover.png');
		  });
	});
	  	$('.hider2').each(function () {
		  $(this).mouseleave(function () {
			$(this).attr('src','/images/existing/Brown_Less.png');
		  });
	});

		$('.shower3').each(function () {
		  $(this).mouseenter(function () {
			$(this).attr('src','/images/existing/Brown_More_Hover.png');
		  });
	});
	  	$('.shower3').each(function () {
		  $(this).mouseleave(function () {
			$(this).attr('src','/images/existing/Brown_More.png');
		  });
	});


	$('.shower4').each(function () {
		$(this).mouseenter(function () {
		  $(this).attr('src','/images/existing/Brown_More_Hover.png');
		});
  });
		$('.shower4').each(function () {
		$(this).mouseleave(function () {
		  $(this).attr('src','/images/existing/Brown_More.png');
		});
  });
  $('.hider4').each(function () {
		$(this).mouseenter(function () {
		  $(this).attr('src','/images/existing/Brown_Less_Hover.png');
		});
  });
		$('.hider4').each(function () {
		$(this).mouseleave(function () {
		  $(this).attr('src','/images/existing/Brown_Less.png');
		});
  });

  $('.shower5').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_More_Hover.png');
	});
});
	$('.shower5').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_More.png');
	});
});
$('.hider5').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_Less_Hover.png');
	});
});
	$('.hider5').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_Less.png');
	});
});

$('.shower6').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_More_Hover.png');
	});
});
	$('.shower6').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_More.png');
	});
});
$('.hider6').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_Less_Hover.png');
	});
});
	$('.hider6').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_Less.png');
	});
});

$('.shower7').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_More_Hover.png');
	});
});
	$('.shower7').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_More.png');
	});
});
$('.hider7').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_Less_Hover.png');
	});
});
	$('.hider7').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_Less.png');
	});
});

$('.shower8').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_More_Hover.png');
	});
});
	$('.shower8').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_More.png');
	});
});
$('.hider8').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_Less_Hover.png');
	});
});
	$('.hider8').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_Less.png');
	});
});

$('.shower9').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_More_Hover.png');
	});
});
	$('.shower9').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_More.png');
	});
});
$('.hider9').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_Less_Hover.png');
	});
});
	$('.hider9').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_Less.png');
	});
});
$('.shower10').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_More_Hover.png');
	});
});
	$('.shower10').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_More.png');
	});
});
$('.hider10').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_Less_Hover.png');
	});
});
	$('.hider10').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_Less.png');
	});
});
$('.shower11').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_More_Hover.png');
	});
});
	$('.shower11').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_More.png');
	});
});
$('.hider11').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_Less_Hover.png');
	});
});
	$('.hider11').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_Less.png');
	});
});
$('.shower12').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_More_Hover.png');
	});
});
	$('.shower12').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_More.png');
	});
});
$('.hider12').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_Less_Hover.png');
	});
});
	$('.hider12').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_Less.png');
	});
});
$('.shower13').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_More_Hover.png');
	});
});
	$('.shower13').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_More.png');
	});
});
$('.hider13').each(function () {
	$(this).mouseenter(function () {
	  $(this).attr('src','/images/existing/Brown_Less_Hover.png');
	});
});
	$('.hider13').each(function () {
	$(this).mouseleave(function () {
	  $(this).attr('src','/images/existing/Brown_Less.png');
	});
});
$( ".readmore1 .shower1" ).click(function() {
			$("#leaderbody1").slideDown();
    $(".shower1").hide();
    $(".hider1").show();
});
$( ".readmore1 .hider1" ).click(function() {
			$("#leaderbody1").slideUp();
    $(".hider1").hide();
    $(".shower1").show();
});

$( ".readmore2 .shower2" ).click(function() {
			$("#leaderbody2").slideDown();
    $(".shower2").hide();
    $(".hider2").show();
});
$( ".readmore2 .hider2" ).click(function() {
			$("#leaderbody2").slideUp();
    $(".hider2").hide();
    $(".shower2").show();
});
$( ".readmore3 .shower3" ).click(function() {
			$("#leaderbody3").slideDown();
    $(".shower3").hide();
    $(".hider3").show();
});
$( ".readmore3 .hider3" ).click(function() {
			$("#leaderbody3").slideUp();
    $(".hider3").hide();
    $(".shower3").show();
});
$( ".readmore4 .shower4" ).click(function() {
	$("#leaderbody4").slideDown();
$(".shower4").hide();
$(".hider4").show();
});
$( ".readmore4 .hider4" ).click(function() {
	$("#leaderbody4").slideUp();
$(".hider4").hide();
$(".shower4").show();
});
$( ".readmore5 .shower5" ).click(function() {
	$("#leaderbody5").slideDown();
$(".shower5").hide();
$(".hider5").show();
});
$( ".readmore5 .hider5" ).click(function() {
	$("#leaderbody5").slideUp();
$(".hider5").hide();
$(".shower5").show();
});
$( ".readmore6 .shower6" ).click(function() {
	$("#leaderbody6").slideDown();
$(".shower6").hide();
$(".hider6").show();
});
$( ".readmore6 .hider6" ).click(function() {
	$("#leaderbody6").slideUp();
$(".hider6").hide();
$(".shower6").show();
});
$( ".readmore7 .shower7" ).click(function() {
	$("#leaderbody7").slideDown();
$(".shower7").hide();
$(".hider7").show();
});
$( ".readmore7 .hider7" ).click(function() {
	$("#leaderbody7").slideUp();
$(".hider7").hide();
$(".shower7").show();
});
$( ".readmore8 .shower8" ).click(function() {
	$("#leaderbody8").slideDown();
$(".shower8").hide();
$(".hider8").show();
});
$( ".readmore8 .hider8" ).click(function() {
	$("#leaderbody8").slideUp();
$(".hider8").hide();
$(".shower8").show();
});
$( ".readmore9 .shower9" ).click(function() {
	$("#leaderbody9").slideDown();
$(".shower9").hide();
$(".hider9").show();
});
$( ".readmore9 .hider9" ).click(function() {
	$("#leaderbody9").slideUp();
$(".hider9").hide();
$(".shower9").show();
});
$( ".readmore10 .shower10" ).click(function() {
	$("#leaderbody10").slideDown();
$(".shower10").hide();
$(".hider10").show();
});
$( ".readmore10 .hider10" ).click(function() {
	$("#leaderbody10").slideUp();
$(".hider10").hide();
$(".shower10").show();
});
$( ".readmore11 .shower11" ).click(function() {
	$("#leaderbody11").slideDown();
$(".shower11").hide();
$(".hider11").show();
});
$( ".readmore11 .hider11" ).click(function() {
	$("#leaderbody11").slideUp();
$(".hider11").hide();
$(".shower11").show();
});
$( ".readmore12 .shower12" ).click(function() {
	$("#leaderbody12").slideDown();
$(".shower12").hide();
$(".hider12").show();
});
$( ".readmore12 .hider12" ).click(function() {
	$("#leaderbody12").slideUp();
$(".hider12").hide();
$(".shower12").show();
});
$( ".readmore13 .shower13" ).click(function() {
	$("#leaderbody13").slideDown();
$(".shower13").hide();
$(".hider13").show();
});
$( ".readmore13 .hider13" ).click(function() {
	$("#leaderbody13").slideUp();
$(".hider13").hide();
$(".shower13").show();
});

	$('.readstorylinkarch').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.readstoryimg1').attr('src','/images/existing/mobile/Brown_Mobile_NewTab_Hover.png');
		});
  });
		$('.readstorylinkarch').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.readstoryimg1').attr('src','/images/existing/mobile/Brown_Mobile_NewTab.png');
		});
  });

		$('.mystorymain .readstorylink').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.readstoryimg1').attr('src','/images/existing/Brown_Next_Hover.png');
		});
  });
		$('.mystorymain .readstorylink').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.readstoryimg1').attr('src','/images/existing/Brown_Next.png');
		});
  });

	$('.newnewlink .readstorylinkinner').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.seestoryimg1').attr('src','/images/existing/mobile/Brown_Mobile_Next_Hover.png');
		});
  });
		$('.newnewlink .readstorylinkinner').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.seestoryimg1').attr('src','/images/existing/mobile/Brown_Mobile_Next.png');
		});
  });


	$('.view-stoies .playlink').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.playimg').attr('src','/images/existing/Brown_Play_Hover.png');
		});
  });
		$('.view-stoies .playlink').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.playimg').attr('src','/images/existing/Brown_Play.png');
		});
  });

		$('.view-stoies .playlink.brown').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.playimg').attr('src','/images/existing/White_Play_Hover.png');
		});
  });
		$('.view-stoies .playlink.brown').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.playimg').attr('src','/images/existing/White_Play.png');
		});
  });

	$('.view-display-id-block_3 .playlink').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.seestoryimg').attr('src','/images/existing/Brown_Play_Hover.png');
		});
  });
		$('.view-display-id-block_3 .playlink').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.seestoryimg').attr('src','/images/existing/Brown_Play.png');
		});
  });

		$('.view-display-id-block_1 .playlink').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.seestoryimg').attr('src','/images/existing/Brown_Play_Hover.png');
		});
  });
		$('.view-display-id-block_1 .playlink').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.seestoryimg').attr('src','/images/existing/Brown_Play.png');
		});
  });

			$('.view-display-id-block_4 .playlink').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.seestoryimg').attr('src','/images/existing/Brown_Play_Hover.png');
		});
  });
		$('.view-display-id-block_4 .playlink').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.seestoryimg').attr('src','/images/existing/Brown_Play.png');
		});
  });

	$('.view-research-resources .reslink').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.resnewtablink').attr('src','/images/existing/Brown_NewTab_Hover.png');
		});
  });
		$('.view-research-resources .reslink').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.resnewtablink').attr('src','/images/existing/Brown_NewTab.png');
		});
  });

	$('.view-resources-library .reslink').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.resnewtablink').attr('src','/images/existing/mobile/Brown_Mobile_NewTab_Hover.png');
		});
  });
		$('.view-resources-library .reslink').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.resnewtablink').attr('src','/images/existing/mobile/Brown_Mobile_NewTab.png');
		});
  });


		$('.view-display-id-block_2 .readstorylink1').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.readstoryimg1').attr('src','/images/existing/Brown_NewTab_Hover.png');
		});
  });
		$('.view-display-id-block_2 .readstorylink1').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.readstoryimg1').attr('src','/images/existing/Brown_NewTab.png');
		});
  });

		$('.view-resources-library .reslink').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.resdownloadlink').attr('src','/images/existing/mobile/Brown_Mobile_Download_Hover.png');
		});
  });
		$('.view-resources-library .reslink').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.resdownloadlink').attr('src','/images/existing/mobile/Brown_Mobile_Download.png');
		});
  });

			$('.view-research-resources .reslink').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.resdownloadlink').attr('src','/images/existing/Brown_Download_Hover.png');
		});
  });
		$('.view-research-resources .reslink').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.resdownloadlink').attr('src','/images/existing/Brown_Download.png');
		});
  });

					$('.trialcrisp .reslink').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.resimgicon img').attr('src','/images/existing/mobile/Brown_Mobile_NewTab_Hover.png');
		});
  });
		$('.trialcrisp .reslink').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.resimgicon img').attr('src','/images/existing/mobile/Brown_Mobile_NewTab.png');
		});
  });



				$('.trialcrisp .reslink').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.reslink').attr('src','/images/existing/Brown_Play_Hover.png');
		});
  });
		$('.trialcrisp .reslink').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.reslink').attr('src','/images/existing/Brown_Play.png');
		});
  });


				$('.inactiveannbox .downloadlink').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.downloadroa').attr('src','/images/existing/mobile/Brown_Mobile_Download_Hover.png');
		});
  });
		$('.inactiveannbox .downloadlink').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.downloadroa').attr('src','/images/existing/mobile/Brown_Mobile_Download.png');
		});
  });


				$('.roalinkfund').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.downloadroafund').attr('src','/images/existing/mobile/White_Mobile_NewTab_Hover.png');
		});
  });
		$('.roalinkfund').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.downloadroafund').attr('src','/images/existing/mobile/White_Mobile_NewTab.png');
		});
  });


			$('.downloadlink2').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.downloadroa').attr('src','/images/existing/Brown_Download_Hover.png');
		});
  });
		$('.downloadlink2').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.downloadroa').attr('src','/images/existing/Brown_Download.png');
		});
  });

		$('.downloadlink3').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.downloadroa').attr('src','/images/existing/Brown_Next_Hover.png');
		});
  });
		$('.downloadlink3').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.downloadroa').attr('src','/images/existing/Brown_Next.png');
		});
  });


	$('.newnewlink .readstorylinkinner').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.readstoryimg1').attr('src','/images/existing/mobile/Brown_Mobile_NewTab_Hover.png');
		});
  });
		$('.newnewlink .readstorylinkinner').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.readstoryimg1').attr('src','/images/existing/mobile/Brown_Mobile_NewTab.png');
		});
  });

			$('.faqbody a').each(function () {
		$(this).mouseenter(function () {
		  $(this).find('.downloadroa').attr('src','/images/existing/Brown_NewTab_Hover.png');
		});
  });
		$('.faqbody a').each(function () {
		$(this).mouseleave(function () {
		  $(this).find('.downloadroa').attr('src','/images/existing/Brown_NewTab.png');
		});
  });
		$('.playlink').each(function () {
   	$(this).on('click', function() {
				//var url = $(this).find("a").attr("href");

             	$(this).next('.modal').find('.modal-body').html('<iframe src="" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" width="720" height="405" frameborder="0"></iframe>');
       					   $("iframe").attr("src", $(this).attr("href"));

    });  });
     const headerLink = document.querySelector('.restitle[href="#collapse11"]');

  if (headerLink) {
    // Go up to the parent .view-grouping
    const grouping = headerLink.closest('.view-grouping');

    if (grouping) {
      // Find all .group-title inside this .view-grouping
      grouping.querySelectorAll('.group-title').forEach(el => {
        el.classList.add('collapse11-group-title');
      });
      grouping.querySelectorAll('.row.group-content').forEach(el => {
        el.classList.add('collapse11-inside');
      });
    }
  }
    const collapse = document.getElementById('collapse11');


  if (collapse) {
    collapse.addEventListener('show.bs.collapse', function () {
      document.querySelectorAll('.group-title.collapse11-group-title').forEach(el => el.style.display = 'block');
    });

    collapse.addEventListener('hide.bs.collapse', function () {
      document.querySelectorAll('.group-title.collapse11-group-title').forEach(el => el.style.display = 'none');
    });
  }


    $(".documentlisting ul.nav-tabs li:first-child a").addClass("active");
    $(".documentlisting .tab-content .tab-pane:first-child").addClass("active");
	});
    //$("#subnav nav ul").addClass("selectmenu");

})(jQuery);;